import { computed } from 'vue'
import { store } from '@remote/store'
import router from '@remote/router'
import { isAndroidNative as isAndroid, isHarmonyNative, isIOSNative as isIOS } from '@xunlei/universal-native-api'

export const useGoHome = () => {

  const isApp = computed(() => {
    return store.state.isApp
  })

  const isMiniProgram = computed(() => {
    return store.state.isMiniProgram
  })

  const isNative = computed(() => {
    return (isAndroid || isIOS || isHarmonyNative || isApp.value || isMiniProgram.value ) && self === top // self === top 为true说明不在iframe中
  })

  const goHome = () => {
    const routeName = String(router.currentRoute.value.name)
    if (!isNative.value) return
    if (!['home', 'login', 'me', 'plugin', 'cinema'].includes(routeName)) {
      // 这个分支我暂时没看懂，但是先不动它，怕出问题。
      router.back()
    } else {
      store.dispatch('close')
    }
  }

  return {
    isNative,
    goHome,
  }
}